import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Intro,
  Showcase,
  Header,
  SectionTitle,
} from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        category={data.category}
        changelog={changelog[data.title].changelog}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        <Intro>
          <p>
            The container, or artboard, is the blank space within which you will
            design and build your layout. It can be used as needed to best
            display a page's content. These assets are available in the Currency
            Figma libraries under Artboards. The container is bounded by the
            breakpoints defined in Currency's{' '}
            <Link
              class="link"
              to={'/' + data.site + '/guidelines/grid-system/design'}
            >
              grid system
            </Link>
            . They do not contain any built-in margin or padding considerations
            to allow for flexibility between products.
          </p>
        </Intro>
        <SectionTitle>Usage</SectionTitle>
        <Showcase
          site={data.site}
          title="Container"
          text="Use the container as needed to build the designed layout. Containers are defined as min-width attributes. Screen sizes in between two defined breakpoint dimensions will inherit all dimensions of the breakpoint one size down."
        >
          <div class="l-container">
            The container is the blank space that constrains the elements of the
            design.
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  /*sticky: `<div class="l-container">
    <div class="l-container__content">
      <p class="c-text-content">Page Content here</p>
      <button class="c-button">Lorem Ipsum</button>
    </div>
    <footer class="p-main-footer l-container__footer">
      <div class="p-main-footer__content">
          <p class="p-main-footer__paragraph--first">© 2019 M&amp;T Bank. All rights reserved.  Users of this website agree to be bound by the provisions of the M&amp;T website <a href="https://www.mtb.com/help-center/policies/terms-of-use" target="_blank" class="p-main-footer__link">Terms of Use</a> and <a href="https://www.mtb.com/help-center/policies/privacy-policy" target="_blank" class="p-main-footer__link">Privacy</a>.</p>
          <div class="p-main-footer__images">
              <svg width="65px" height="59px" viewBox="0 0 65 59" version="1.1">
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Artboard" fill="#787878">
                          <path d="M33.22552,15 L13,26.5103097 L13,30.6698474 L16.098522,30.6698474 L16.098522,44.9721261 L49.8451281,44.9721261 L49.8451281,30.6698474 L53,30.6698474 L53,26.6242136 L33.22552,15 Z M20.2101382,26.9697782 L33.2240751,19.3343668 L45.9565034,26.9697782 L45.9565034,41.3288884 L20.2101382,41.3288884 L20.2101382,26.9697782 Z M26.30267,32.4376449 L39.7671653,32.4376449 L39.7671653,28.9049396 L26.30267,28.9049396 L26.30267,32.4376449 Z M26.30267,37.6991361 L39.7671653,37.6991361 L39.7671653,34.1661901 L26.30267,34.1661901 L26.30267,37.6991361 Z" id="Page-1-Copy"></path>
                      </g>
                  </g>
              </svg>
          </div>
          <p class="p-main-footer__paragraph--last">Equal Housing Lender. M&amp;T Bank, Member FDIC.</p>
      </div>
    </footer>
  </div>
  `,*/
}
